import type { SubscribeResult } from "@hooks/useSubscribe";

/**
 * A purchase attempt may finish without granting Premium (for example when
 * the user cancels, Ask to Buy is pending, or the store returns an error).
 * Those outcomes must remain recoverable on the paywall; only RevenueCat's
 * verified entitlement result is allowed to complete onboarding.
 */
export const shouldCompletePaywallPurchase = (
  result: SubscribeResult | undefined,
) => result?.success === true;
